export default function getCurrentTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}
